import SnapshotImage from "./SnapshotImage";

export default SnapshotImage;
